module.exports = {"transport":"http","websocket":"wss://api.hive.blog:8090","uri":"https://anyx.io","url":"https://anyx.io","dev_uri":"https://api.steemitdev.com","stage_uri":"https://api.steemitstage.com","address_prefix":"STM","chain_id":"0000000000000000000000000000000000000000000000000000000000000000","alternative_api_endpoints":["https://api.hive.blog","https://anyx.io"],"failover_threshold":3}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 82
// module chunks = 0 1